export const RANGE_GTM_TRACKING_VALUES = {
  componentName: {
    modelRange: 'model-range-component',
    gradeRange: 'grade-range-component',
  },
  action: {
    selectModel: 'select-model',
    browseModel: 'browse-model',
    selectGrade: 'select-grade',
    selectModelVideo: 'select-model-video',
    expandFeature: 'expand-feature',
    selectExteriorColour: 'select-exterior-colour',
    selectInteriorColour: 'select-interior-colour',
    selectWheels: 'select-wheels',
    selectAccessories: 'select-accessories',
    spinCar: 'spin-car'
  },
  label: {    
    viewCarDetails: 'view-car-details',
    keepInformed: 'keep-me-informed',
    reserve: 'online-car-reservation',
    features: 'view-car-details',
    viewSpecs: 'view-specs',
    customize: 'customize'
  }
};